import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store';
import { useLogoutMutation } from '../api/authApi';
import { clearAuthResponse } from '../state/authSlice';
import { api } from '../../../api';
import { toast } from 'react-toastify';

export const useLogout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [logout, { isLoading }] = useLogoutMutation();
  const logoutUser = async () => {
    try {
      await logout().unwrap();
      dispatch(clearAuthResponse());
      dispatch(api.util.resetApiState());
      navigate('/');
      toast('Logged out successfully', { type: 'success' });
    } catch (error) {
      console.error(error);
    }
  };
  return { logoutUser, loadingLogout: isLoading };
};
